import { func } from 'prop-types';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Print from '@alltrails/shared/icons/Print';
import { wrapEventHandler } from '../../../utils/handlers';
import { useIntl } from '@alltrails/shared/react-intl';

const CtaControls = ({ handlePrintClick }) => {
  const intl = useIntl();

  if (handlePrintClick) {
    return (
      <IconButton
        icon={{ Component: Print }}
        onClick={wrapEventHandler(handlePrintClick)}
        title={intl.formatMessage({ defaultMessage: 'Print map' })}
        testId="map-controls-print"
        variant="elevated"
      />
    );
  }
  return null;
};

CtaControls.propTypes = {
  handlePrintClick: func
};

CtaControls.defaultProps = {
  handlePrintClick: null
};

export default CtaControls;
